import React from 'react';
import { blindSlot } from 'shared/data/tooltips';
import CheckboxComponent from 'shared/components/CheckboxComponent';

const BlindSlot = (props) => {
  const name = 'blind_slot';
  const {
    parameters,
    onChangeParameter,
    groupName,
    className,
    label,
    required,
  } = props;

  return (
    <CheckboxComponent
      name={name}
      inputId={name}
      label={label}
      checked={parameters[name] === '1'}
      onChange={(e) => onChangeParameter(name, e.target.checked ? '1' : '0')}
      required={required}
      groupName={groupName}
      className={className} />
  );
};

BlindSlot.defaultProps = {
  tooltip: blindSlot,
  label: 'Blind Slot',
};

export default BlindSlot;
